<script>
    export let category;
</script>

<div class="category-container" on:click on:keypress>
    {category.title}
    {#if category.img}
        <div class="category-container-image">
            <img class="category-image"src={category.img} alt="Category" />
        </div>
    {/if}
</div>

<style>
    .category-container {
        display: flex;
        position: relative;
        border-radius: 10px;
        margin-left: 10px;
        margin-bottom: 10px;
        height: 40px;
        min-width: 18vw;
        width: 15%;
        border: 2px solid var(--color-primary);
        background-color: var(--color-white);
        color: var(--color-primary);
        font-size: 2.6vw;
        text-align: center;
        align-items: center;
        justify-content: center;
        box-shadow: 0 5px var(--color-secondary);
        overflow: hidden;
        padding: 5px;
        cursor: pointer;
        transition: all 0.2s;
    }

    .category-container:active {
        box-shadow: 0 2px var(--color-secondary);
        transform: translateY(3px); 
        transition: all 0.2s;

    }

    .category-container:hover .category-container-image {
        top: 0%;
        transition: top 0.4s ease-in-out;
    }

    .category-container-image {
        position: absolute;
        width: 100%;
        height: 100%;
        top: -100%;
        transition: top 0.4s ease-in-out;
        background-color: var(--color-white);
    }

    .category-image {
        margin-top: 3%;
        height: 90%;
        max-width: 90%;
    }

    @media only screen and (min-width: 768px) {
        .category-container {
            height: 100px;
            min-width: 15vw;
            width: 20%;
            font-size: 1.6vw;
        }
    }

    @media only screen and (min-width: 1850px) {
        .category-container {
            font-size: 28px;
        }
    }

</style>